import type { HTMLAttributes } from 'react';
import styles from './Skeleton.module.css';

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  variant?: 'text' | 'circular' | 'rectangular';
}

export const Skeleton = ({
  width,
  height,
  borderRadius,
  variant = 'text',
  className = '',
  style,
  ...props
}: SkeletonProps) => {
  const classNames = [
    styles.skeleton,
    styles[variant],
    className,
  ].filter(Boolean).join(' ');

  const inlineStyle = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    borderRadius,
    ...style,
  };

  return (
    <div
      className={classNames}
      style={inlineStyle}
      aria-hidden="true"
      {...props}
    />
  );
};


